<template>
	<div id="clientCustomizer" class="w-100">
		<MediaLibraryModal v-on:mediaInsert="insertPhoto($event)" v-on:hideMediaModal="hideMediaModal()" />
		<DataSelectModal :type="dataSelectType" v-on:selectDataItem="selectDataItem($event)" />
		<div class="customizer2-wrapper">
			<!-- Customizer HTML Content Preview -->
			<div class="customizer2-content">
				<div v-if="loadingPage" class="customizer2-content-loader">
					Loading
					<font-awesome-icon :class="'fa-spin ms-2'" :icon="['fas', 'spinner']" />
				</div>
				<div v-html="'<style>' + settingsCss + '</style>'"></div>
				<div v-html="'<style>' + themeCss + '</style>'"></div>
				<div v-html="'<style>' + fontsCss + '</style>'"></div>
				<div v-html="'<style>' + headerCss + '</style>'"></div>
				<div v-html="'<style>' + homepageCss + '</style>'"></div>
				<div v-html="header.html"></div>
				<template v-for="section in homepageSections">
					<section :key="section.id + 'div'" :id="section.id" v-if="section.visible">
						<button data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample" class="btn btn-primary btn-sm section-customize-btn">
							<font-awesome-icon :icon="['fas', 'palette']" />
						</button>
						<div v-html="section.content"></div>
					</section>
				</template>
				<div v-html="'<style>' + footerCss + '</style>'"></div>
				<div v-html="footer.html"></div>
				<!-- <div>
					<iframe width="100%" style="height:100vh" :srcdoc="websiteData"></iframe>
				</div> -->
			</div>
			<!-- #Customizer HTML Content Preview -->
		</div>
		<!-- Modal -->
		<div class="modal fade" id="chooseCustomizationModal" tabindex="-1" aria-labelledby="chooseCustomizationModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="chooseCustomizationModalLabel">Customization Data</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<div class="alert alert-light rounded" role="alert">
							<h4 class="alert-heading text-black">Choose client customization data to apply!</h4>
							<small>
								Here we can choose homepage customization to apply from other clients (if we need similar website with existing client). This functionality will
								copy all necessery files exept <code>images</code> they need to be added after.🧑‍💻
							</small>
						</div>
						<div class="clients-wrapper">
							<div class="d-flex justify-content-between align-items-center mb-2" v-for="dClient in clients" :key="dClient.id">
								<div class="client-data fs-5">
									{{ dClient.name }}
									<span v-if="dClient.id == client.id" class="badge bg-primary ms-2">active</span>
								</div>
								<div class="client-actions">
									<button class="btn btn-primary btn-sm" @click="selectCustomizerData(dClient.id)">
										Choose
									</button>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
						<button type="button" @click="applyChangedData()" class="btn btn-primary">
							Apply data on selected customizer settings
						</button>
					</div>
				</div>
			</div>
		</div>
		<button
			style="position: absolute;top: 27px;left: 19px;z-index: 999;"
			class="btn btn-primary"
			type="button"
			data-bs-toggle="offcanvas"
			data-bs-target="#offcanvasExample"
			aria-controls="offcanvasExample"
		>
			Customize
		</button>
		<!-- Customizer -->
		<div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
			<div class="offcanvas-header">
				<h5 class="offcanvas-title" id="offcanvasExampleLabel">{{ client.name }}</h5>
				<button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
			</div>
			<div class="offcanvas-body">
				<div class="d-flex justify-content-between align-items-center">
					<div class="text-white"></div>
				</div>

				<!-- Customizer Heading -->
				<div class="customizer-heading">
					<small class="p-0 m-0 d-flex justify-content-between align-items-center"
						>You are customizing <router-link class="btn" :to="'/juniper/clients/edit/' + this.$route.params.id">x</router-link></small
					>
					<h5>
						{{ client.name }}
					</h5>
				</div>
				<!-- #Customizer Heading -->
				<!-- Theme Active -->
				<div v-if="sidebarMenu" class="theme">
					<h5>Theme</h5>
					<div class="form-group">
						<select @change="changeTheme()" class="form-select" v-model="themeOptions.theme_active">
							<option v-for="(theme, i) in themes" :value="theme" :key="i"> {{ theme }}</option>
						</select>
					</div>
				</div>
				<!-- #Theme Active -->

				<!-- Sidebar Menu -->
				<div class="sidebar-menu" v-if="sidebarMenu">
					<div class="list-group">
						<button type="button" @click="showSettings('theme')" class="list-group-item list-group-item-action">
							Theme Settings
						</button>
						<button type="button" @click="showSettings('header')" class="list-group-item list-group-item-action">
							Header Settings
						</button>
						<button type="button" @click="showSettings('homepage')" class="list-group-item list-group-item-action">
							Homepage Sections
						</button>
						<button type="button" class="list-group-item list-group-item-action" disabled>
							Menus 🧑‍💻
						</button>
						<button type="button" @click="showSettings('footer')" class="list-group-item list-group-item-action">
							Footer Settings
						</button>
					</div>
				</div>
				<!-- #Sidebar Menu -->

				<!-- Theme Settings -->
				<div v-if="activeSidebarSettings === 'theme'" class="settings-part theme-settings">
					<div class="settings-part-header">
						<button @click="backToSidebarMenu()">
							<font-awesome-icon :icon="['fas', 'chevron-left']" class="" />
						</button>
						<div class="title">
							<small>Customizing</small>
							<h5>Theme</h5>
						</div>
					</div>
					<div class="settings-part-content">
						<!-- Theme Sections Wrapper -->
						<div class="footer-wrapper">
							<!-- Theme Content -->
							<div class="mt-3" v-if="themeOptions.theme_settings_json.length > 0">
								<h5>Default Settings</h5>
								<div class="form-group mb-2" v-for="variable in themeOptions.theme_settings_json" :key="variable.name">
									<CustomizerProperty
										:data="variable"
										:googleFonts="googleFonts"
										:type="'theme-settings'"
										:themeOptions="themeOptions.theme_settings_json"
										v-on:updatePreview="updatePreview($event)"
										v-on:showMediaLibraryModal="showMediaModal($event)"
									/>
								</div>
							</div>
							<div v-else class="text-center mt-3">
								No Theme Settings for this theme 😔
							</div>
						</div>
						<!-- #Theme Sections Wrapper -->
					</div>
				</div>

				<!-- Homepage Settings -->
				<div v-if="activeSidebarSettings === 'homepage'" class="settings-part homepage-settings">
					<div class="settings-part-header">
						<button @click="backToSidebarMenu()">
							<font-awesome-icon :icon="['fas', 'chevron-left']" class="" />
						</button>
						<div class="title">
							<small>Customizing</small>
							<h5>Homepage</h5>
						</div>
					</div>
					<div class="settings-part-content">
						<!-- Homepage Sections Wrapper -->
						<div v-if="homepageSections.length > 0" class="homepage-sections-wrapper">
							<h5>Homepage sections</h5>
							<draggable v-model="homepageSections" @change="updateHomepageSectionsOrder()">
								<transition-group class="list-group">
									<div
										class="list-group-item list-group-item-action"
										:class="{ 'not-visible': !section.visible }"
										v-for="(section, i) in homepageSections"
										:key="section.id"
									>
										<button @click="section.visible = !section.visible" class="btn p-0 m-0">
											<font-awesome-icon v-if="section.visible" :icon="['fas', 'eye']" class="me-2" />
											<font-awesome-icon v-else :icon="['fas', 'eye-slash']" class="me-2" />
										</button>
										{{ section.name }}
										<button
											v-if="section.variables.length > 0"
											class="btn btn-primary float-end p-2"
											@click="openHomepageSectionSettings(i)"
											style="border-radius:50%"
											title="This section have mutable variables"
										>
											<font-awesome-icon style="font-size:10px" :icon="['fas', 'edit']" class="float-end" />
										</button>
									</div>
								</transition-group>
							</draggable>
							<div class="section-variables">
								<div v-for="(section, i) in homepageSections" :key="section.id">
									<div v-if="section.variables.length > 0 && section.settings" class="section-settings border mt-2 rounded-2 p-2 bg-white">
										<div class="d-flex justify-content-between align-items-center">
											<h5 class="p-0 m-0">{{ section.name }} settings</h5>
											<button @click="closeHomepageSectionSettings()" class="btn p-0 m-0">
												x
											</button>
										</div>

										<div class="form-group mb-2" v-for="variable in section.variables" :key="variable.name">
											<CustomizerProperty
												:data="variable"
												:googleFonts="googleFonts"
												:type="'homepage'"
												:sectionIndex="i"
												:themeOptions="themeOptions.theme_settings_json"
												v-on:updatePreview="updatePreview($event)"
												v-on:showMediaLibraryModal="showMediaModal($event)"
												v-on:showDataSelectModal="showDataSelectModal($event)"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- #Homepage Sections Wrapper -->
					</div>
				</div>
				<!-- #Homepage Settings -->

				<!-- Header Settings -->
				<div v-if="activeSidebarSettings === 'header'" class="settings-part header-settings">
					<div class="settings-part-header">
						<button @click="backToSidebarMenu()">
							<font-awesome-icon :icon="['fas', 'chevron-left']" class="" />
						</button>
						<div class="title">
							<small>Customizing</small>
							<h5>Header</h5>
						</div>
					</div>
					<div class="settings-part-content">
						<!-- Header Sections Wrapper -->

						<div class="headers-wrapper">
							<!-- Header Template-->

							<div class="d-flex justify-content-between align-items-center">
								<h6 class="p-0 m-0">
									Template
								</h6>
								<div class="form-group" style="width:180px">
									<select @change="getHeader(themeOptions.theme_active)" class="form-select" v-model="themeOptions.theme_header_active">
										<option v-for="(header, i) in headers" :value="header" :key="i + '-header'"> {{ header }}</option>
									</select>
								</div>
							</div>
							<!-- #Header Template -->

							<!-- Header Content -->
							<div class="mt-3" v-if="header.variables.length > 0">
								<h5>Header content</h5>
								<div class="form-group mb-2" v-for="variable in header.variables" :key="variable.name">
									<CustomizerProperty
										:data="variable"
										:googleFonts="googleFonts"
										:type="'header'"
										:sectionIndex="0"
										:themeOptions="themeOptions.theme_settings_json"
										v-on:updatePreview="updatePreview($event)"
										v-on:showMediaLibraryModal="showMediaModal($event)"
									/>
								</div>
							</div>
							<div v-else class="text-center mt-3">
								No settings for this header 😔
							</div>
							<!-- #Header Content -->
						</div>
						<!-- #Footer Sections Wrapper -->
					</div>
				</div>
				<!-- #Header Settings -->

				<!-- Footer Settings -->
				<div v-if="activeSidebarSettings === 'footer'" class="settings-part footer-settings">
					<div class="settings-part-header">
						<button @click="backToSidebarMenu()">
							<font-awesome-icon :icon="['fas', 'chevron-left']" class="" />
						</button>
						<div class="title">
							<small>Customizing</small>
							<h5>Footer</h5>
						</div>
					</div>
					<div class="settings-part-content">
						<!-- Footer Sections Wrapper -->
						<div class="footer-wrapper">
							<!-- Footer Template-->
							<div class="d-flex justify-content-between align-items-center">
								<h6 class="p-0 m-0">
									Template
								</h6>
								<div class="form-group" style="width:180px">
									<select @change="getFooter(themeOptions.theme_active)" class="form-select" v-model="themeOptions.theme_footer_active">
										<option v-for="(footer, i) in footers" :value="footer" :key="i + 'footer'"> {{ footer }}</option>
									</select>
								</div>
							</div>
							<!-- #Footer Template -->

							<!-- Footer Content -->
							<div class="mt-3" v-if="footer.variables.length > 0">
								<h5>Footer content</h5>
								<div class="form-group mb-2" v-for="variable in footer.variables" :key="variable.name">
									<CustomizerProperty
										:data="variable"
										:googleFonts="googleFonts"
										:type="'footer'"
										:sectionIndex="0"
										:themeOptions="themeOptions.theme_settings_json"
										v-on:updatePreview="updatePreview($event)"
										v-on:showMediaLibraryModal="showMediaModal($event)"
									/>
								</div>
							</div>
							<div v-else class="text-center mt-3">
								No settings for this footer 😔
							</div>
							<!-- #Footer Content -->
						</div>
						<!-- #Footer Sections Wrapper -->
					</div>
				</div>
				<!-- #Footer Settings -->

				<div class="update">
					<button :disabled="updateLoading" @click="saveClientThemeSettings()" class="btn btn-primary w-100">
						<font-awesome-icon :icon="['fas', updateLoading ? 'spinner' : 'save']" :class="[updateLoading ? 'fa-spin' : '']" />
						Update
					</button>
					<button :disabled="staticLoading" @click="generateStatic()" class="btn btn-outline-light w-100 mt-2">
						<font-awesome-icon :icon="[staticLoading ? 'fas' : 'fab', staticLoading ? 'spinner' : 'html5']" :class="[staticLoading ? 'fa-spin' : '']" />
						Generate Static
					</button>

					<button data-bs-toggle="modal" data-bs-target="#chooseCustomizationModal" class="btn btn-outline-light w-100 mt-4" v-if="authUser.email.includes('srdjan')">
						<font-awesome-icon :icon="['fas', 'cloud-download-alt']" />
						Get homepage configuration
					</button>
				</div>
				<div>
					Some text as placeholder. In real life you can have the elements you have chosen. Like, text, images, lists, etc.
				</div>
				<div class="dropdown mt-3">
					<button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown">
						Dropdown button
					</button>
					<ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
						<li><a class="dropdown-item" href="#">Action</a></li>
						<li><a class="dropdown-item" href="#">Another action</a></li>
						<li><a class="dropdown-item" href="#">Something else here</a></li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import juniperApi from '@/api/juniperApi'
import draggable from 'vuedraggable'
import CustomizerProperty from '@/components/juniper/customizer/CustomizerProperty'
import MediaLibraryModal from '@/components/juniper/media/MediaLibraryModal'
import DataSelectModal from '../../../components/juniper/customizer/modals/DataSelectModal.vue'
import { Modal } from 'bootstrap'

//import restApi from '../../../api/index'

export default {
	name: 'ClientCustomizer2',
	data() {
		return {
			loading: false,
			staticLoading: false,
			updateLoading: false,
			sidebarMenu: true,
			activeSidebarSettings: '',
			client: {},
			themes: [],
			headers: [],
			footers: [],
			themeOptions: {
				theme_active: 'default',
				theme_homepage_active: 'default',
				theme_homepage_sections_json: [],
				theme_footer_active: 'default',
				theme_footer_json: [],
				theme_settings_json: [],
			},
			settingsCss: ':root{--primary-color:#00a08d;--secondary-color:#002447;--tertiary-color: #cfeae7;}',
			themeCss: '',
			homepageCss: '',
			header: '',
			headerCss: '',
			homepageSections: [],
			footer: '',
			footerCss: '',
			mainCss: '',
			fontsCss: '',
			updateFooter: false,
			updateHeader: false,
			googleFonts: [
				'Roboto',
				'Nunito sans',
				'Oswald',
				'Raleway',
				'Merriweather',
				'Overpass',
				'Lora',
				'Libre Franklin',
				'Martel Sans',
				'Open Sans',
				'Inter',
				'Oxygen',
				'Spartan',
				'Dancing Script',
			],
			websiteData: '',
			themeJs: '',
			jqueryScript: '',
			showMediaLibrary: false,
			$mediaModal: null,
			mediaElement: null,
			dataSelectType: '',
			dataSelectItem: {},
			clients: [],
			loadingPage: true,
		}
	},
	components: { draggable, CustomizerProperty, MediaLibraryModal, DataSelectModal },
	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']),
		homepageSectionsWatch() {
			return Object.assign({}, this.homepageSections)
		},
	},

	mounted: function() {
		this.$mediaModal = new Modal('#mediaLibraryModal')
		this.$dataSelectModal = new Modal('#dataSelectModal')
		this.$sectionCustomizeModal = new Modal('#sectionCustomizeModal')
		window.setInterval(() => {
			// Interval
		}, 5000)
	},

	watch: {},

	async created() {
		await this.attachScripts()
		this.getClients()
		this.getClient()
	},

	methods: {
		async attachScripts() {
			await this.loadJquery()
			await this.loadMarquee()
			await this.loadFontAwesome()
			await this.loadOwl2Css()
			await this.loadOwl2Js()
			await this.loadMask()
		},

		// Load jQuery in VUE
		loadJquery() {
			return new Promise(resolve => {
				let scriptEl = document.createElement('script')
				scriptEl.src = 'https://code.jquery.com/jquery-3.6.3.min.js'
				scriptEl.type = 'text/javascript'
				scriptEl.integrity = 'sha256-pvPw+upLPUjgMXY0G+8O0xUf+/Im1MZjXxxgOcBQBXU='
				scriptEl.crossOrigin = 'anonymus'
				document.getElementsByTagName('head')[0].appendChild(scriptEl)
				scriptEl.onload = function() {
					resolve()
				}
			})
		},

		loadMarquee() {
			return new Promise(resolve => {
				let scriptMq = document.createElement('script')
				scriptMq.src = 'https://cdn.jsdelivr.net/npm/jquery.marquee@1.6.0/jquery.marquee.min.js'
				scriptMq.type = 'text/javascript'
				document.getElementsByTagName('head')[0].appendChild(scriptMq)
				scriptMq.onload = function() {
					resolve()
				}
			})
		},

		loadFontAwesome() {
			return new Promise(resolve => {
				let linkFa = document.createElement('link')
				linkFa.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css'
				linkFa.integrity = 'sha512-MV7K8+y+gLIBoVD59lQIYicR65iaqukzvf/nwasF0nqhPay5w/9lJmVM2hMDcnK1OnMGCdVK+iQrJ7lzPJQd1w=='
				linkFa.crossOrigin = 'anonymus'
				linkFa.referrerpolicy = 'no-referrer'
				linkFa.rel = 'stylesheet'
				document.getElementsByTagName('head')[0].appendChild(linkFa)
				linkFa.onload = function() {
					resolve()
				}
			})
		},

		loadOwl2Css() {
			return new Promise(resolve => {
				let linkOw = document.createElement('link')
				linkOw.href = 'https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/assets/owl.carousel.min.css'
				linkOw.integrity = 'sha512-tS3S5qG0BlhnQROyJXvNjeEM4UpMXHrQfTGmbQ1gKmelCxlSEBUaxhRBj/EFTzpbP4RVSrpEikbmdJobCvhE3g=='
				linkOw.crossOrigin = 'anonymus'
				linkOw.referrerpolicy = 'no-referrer'
				linkOw.rel = 'stylesheet'
				document.getElementsByTagName('head')[0].appendChild(linkOw)
				linkOw.onload = function() {
					resolve()
				}
			})
		},

		loadOwl2Js() {
			return new Promise(resolve => {
				let scriptOw = document.createElement('script')
				scriptOw.src = 'https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js'
				scriptOw.type = 'text/javascript'
				scriptOw.integrity = 'sha512-bPs7Ae6pVvhOSiIcyUClR7/q2OAsRiovw4vAkX+zJbw3ShAeeqezq50RIIcIURq7Oa20rW2n2q+fyXBNcU9lrw=='
				scriptOw.crossOrigin = 'anonymus'
				scriptOw.referrerpolicy = 'no-referrer'
				document.getElementsByTagName('head')[0].appendChild(scriptOw)
				scriptOw.onload = function() {
					resolve()
				}
			})
		},

		loadMask() {
			return new Promise(resolve => {
				let scriptMask = document.createElement('script')
				scriptMask.src = 'https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/0.9.0/jquery.mask.min.js'
				scriptMask.type = 'text/javascript'
				scriptMask.integrity = 'sha512-oJCa6FS2+zO3EitUSj+xeiEN9UTr+AjqlBZO58OPadb2RfqwxHpjTU8ckIC8F4nKvom7iru2s8Jwdo+Z8zm0Vg=='
				scriptMask.crossOrigin = 'anonymus'
				scriptMask.referrerpolicy = 'no-referrer'
				document.getElementsByTagName('head')[0].appendChild(scriptMask)
				scriptMask.onload = function() {
					resolve()
				}
			})
		},

		executeScript(script) {
			eval(script)
			this.loadingPage = false
		},

		getClients() {
			this.loading = true
			juniperApi
				.get('/clients', { params: { all: true } })
				.then(({ data }) => {
					this.clients = data
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Get Client
		 * Function getting data for client from database
		 */
		async getClient() {
			this.loading = true
			juniperApi
				.get('/clients/' + this.$route.params.id)
				.then(({ data }) => {
					this.client = data
					this.getClientThemeOptions(this.$route.params.id)
					this.getThemesList()
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					console.log(error)
				})
		},

		/**
		 * Get Themes List
		 * Function getting all themes list from Juniper
		 */
		getThemesList() {
			juniperApi
				.post('/themes/list')
				.then(({ data }) => {
					this.themes = data
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Get Theme Footers List
		 * Function getting all footer templates for given theme
		 */
		getThemeFootersList(theme) {
			juniperApi
				.post('/themes/' + theme + '/footers')
				.then(({ data }) => {
					this.footers = data
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Get Theme Headers List
		 * Function getting all header templates for given theme
		 */
		getThemeHeadersList(theme) {
			juniperApi
				.post('/themes/' + theme + '/headers')
				.then(({ data }) => {
					this.headers = data
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Get Theme Homepage Sections
		 * Function getting all homepage sections for given theme
		 */
		getThemeHomepageSections(theme, clientId) {
			juniperApi
				.post('/themes/' + theme + '/homepage/sections', { client_id: clientId })
				.then(({ data }) => {
					this.homepageSections = data
					this.getClientHomepageSections()
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Update Homepage Sections Order
		 * Function updates order of sections on homepage
		 */
		updateHomepageSectionsOrder() {
			const newList = [...this.homepageSections].map((item, index) => {
				const newSort = index + 1
				// also add in a new property called has changed if you want to style them / send an api call
				item.hasChanged = item.order !== newSort
				if (item.hasChanged) {
					item.order = newSort
				}
				return item
			})
			this.homepageSections = newList
		},

		/**
		 * Get Client Homepage Sections
		 * Function get all client homepage sections
		 */
		getClientHomepageSections() {
			this.homepageSections.forEach(hs => {
				let opt = this.themeOptions.theme_homepage_sections_json.find(s => s.code === hs.code)
				if (opt) {
					hs.order = opt.order
					hs.visible = opt.visible
				}
			})
			this.homepageSections.sort((a, b) => a.order - b.order)
			this.updateHomepageSectionsCss()
		},

		/**
		 * Save Client Theme Settings
		 * Function saves client theme settings (options) to database
		 */
		saveClientThemeSettings() {
			this.updateLoading = true
			let theme_homepage_sections_json = JSON.parse(JSON.stringify(this.homepageSections))
			theme_homepage_sections_json.forEach(s => {
				delete s.content
				delete s.id
				delete s.name
				delete s.hasChanged
				return s
			})

			let params = JSON.parse(JSON.stringify(this.themeOptions))

			// Home sections variables
			params.theme_homepage_sections_json = theme_homepage_sections_json

			// Footer Variables
			params.theme_footer_json = this.footer.variables
			// Header Variables
			params.theme_header_json = this.header.variables

			juniperApi
				.post('/options/' + this.$route.params.id + '/save', { params: params })
				.then(({ data }) => {
					this.getClient()
					this.executeScript(data.js)
					this.updateLoading = false
					this.$swal.fire({
						icon: 'success',
						title: data.message,
						timer: 2000,
					})
				})
				.catch(error => {
					this.updateLoading = false
					console.log(error)
				})
		},

		/**
		 * Regenerate static content
		 * TODO: Based on changes regenerate only homepage or all pages
		 */
		generateStatic() {
			this.$swal
				.fire({
					title: 'Do you want to regenerate static content?',
					text: `All pages that have changes will be regenerated again! Note that unsaved changes will not apply to static!`,
					icon: 'warning',
					position: 'center',
					showCancelButton: true,
					showConfirmButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, regenerate!',
					toast: false,
					timer: 0,
				})
				.then(result => {
					if (result.isConfirmed) {
						this.staticLoading = true
						juniperApi
							.post('/clients/' + this.$route.params.id + '/static/generate')
							.then(({ data }) => {
								this.$swal.fire({
									icon: 'success',
									title: data.message,
									timer: 4000,
								})
								this.staticLoading = false
							})
							.catch(error => {
								this.staticLoading = false
								console.log(error)
							})
					}
				})
		},

		/**
		 * Get Client Theme Options
		 * Function takes client theme options from database
		 */
		getClientThemeOptions(clientId) {
			juniperApi
				.post('/options/' + clientId, { selector: 'theme_' })
				.then(({ data }) => {
					this.themeOptions = data
					this.getClientThemeSettings(data.theme_active, clientId)
					this.updateThemeSettingsPreview()
					this.getThemeCss(data.theme_active)
					this.getThemeHomepageSections(data.theme_active, clientId)
					this.getFooter(data.theme_active, clientId)
					this.getThemeFootersList(this.themeOptions.theme_active)
					this.getHeader(data.theme_active, clientId)
					this.getThemeHeadersList(this.themeOptions.theme_active)
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Change Theme
		 * Function change theme
		 */
		changeTheme() {
			this.getThemeCss(this.themeOptions.theme_active)
			this.getThemeHomepageSections(this.themeOptions.theme_active, this.$route.params.id)
			this.getFooter(this.themeOptions.theme_active, this.$route.params.id)
			this.getThemeFootersList(this.themeOptions.theme_active)
			this.getHeader(this.themeOptions.theme_active, this.$route.params.id)
			this.getThemeHeadersList(this.themeOptions.theme_active)
		},

		// Open homepage section settings
		openHomepageSectionSettings(index) {
			this.homepageSections.forEach(sec => {
				sec.settings = false
			})
			this.homepageSections[index].settings = true
		},

		// Close homepage section settings
		closeHomepageSectionSettings() {
			this.homepageSections.forEach(sec => {
				sec.settings = false
			})
		},

		// Show homepage settings
		showSettings(type) {
			this.activeSidebarSettings = type
			this.sidebarMenu = false
		},

		// Back to sidebar menu
		backToSidebarMenu() {
			this.sidebarMenu = true
			this.activeSidebarSettings = ''
		},

		/**
		 * Get Theme CSS
		 * Function return theme css data
		 */
		getThemeCss(theme) {
			juniperApi
				.post('/themes/' + theme + '/css')
				.then(({ data }) => {
					this.themeCss = data
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Get Header
		 * Function return header data
		 */
		getHeader(theme, clientId = null) {
			if (clientId == null) {
				clientId = this.$route.params.id
			}
			juniperApi
				.post('/themes/' + theme + '/header', {
					client_id: clientId,
					template: this.themeOptions.theme_header_active,
				})
				.then(({ data }) => {
					this.header = data
					// eslint-disable-next-line
					this.themeJs = data.js
					// this.loadScripts().then(() => {
					this.executeScript(data.js)
					//})
					this.updateHeaderCss(this.header)
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Get Footer
		 * Function return footer data
		 */
		getFooter(theme, clientId = null) {
			if (clientId == null) {
				clientId = this.$route.params.id
			}
			juniperApi
				.post('/themes/' + theme + '/footer', {
					client_id: clientId,
					template: this.themeOptions.theme_footer_active,
				})
				.then(({ data }) => {
					this.footer = data
					this.updateFooterCss(this.footer)
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Update Header CSS
		 * Update css file with css variables from header
		 */
		updateHeaderCss(header) {
			let headerCss = ''
			header.variables.forEach(variable => {
				if (variable.name.includes('_CSS')) {
					let cssAttributeName = variable.name.toLowerCase().substring(0, variable.name.indexOf('_'))
					let cssAttributeValue = variable.value
					let cssAttributeSelector = variable.selector || 'header'
					if (cssAttributeValue && cssAttributeValue !== '') {
						if (cssAttributeName === 'font-family') {
							this.fontsCss += `@import url('https://fonts.googleapis.com/css?family=${cssAttributeValue}&display=swap');\n`
							headerCss += `${cssAttributeSelector} {\n ${cssAttributeName}:'${cssAttributeValue}';\n }\n`
						} else {
							headerCss += `${cssAttributeSelector} {\n ${cssAttributeName}:${cssAttributeValue};\n }\n`
						}
					}
				}
			})
			this.headerCss = headerCss
		},

		/**
		 * Update Footer CSS
		 * Update css file with css variables from footer
		 */
		updateFooterCss(footer) {
			let footerCss = ''
			footer.variables.forEach(variable => {
				if (variable.name.includes('_CSS')) {
					let cssAttributeName = variable.name.toLowerCase().substring(0, variable.name.indexOf('_'))
					let cssAttributeValue = variable.value
					let cssAttributeSelector = variable.selector || 'footer'
					if (cssAttributeValue && cssAttributeValue !== '') {
						if (cssAttributeName === 'font-family') {
							if (!this.fontsCss.includes(cssAttributeValue)) {
								this.fontsCss += `@import url('https://fonts.googleapis.com/css?family=${cssAttributeValue}&display=swap');\n`
							}
							footerCss += `${cssAttributeSelector} {\n ${cssAttributeName}:'${cssAttributeValue}';\n }\n`
						} else {
							footerCss += `${cssAttributeSelector} {\n ${cssAttributeName}:${cssAttributeValue};\n }\n`
						}
					}
				}
			})
			this.footerCss = footerCss
		},

		/**
		 * Update Homepage Sections CSS
		 * Update css file with css variables from homepage sections
		 */
		updateHomepageSectionsCss() {
			let homepageCss = ''

			this.homepageSections.forEach(section => {
				section.variables.forEach(variable => {
					if (section.visible) {
						if (variable.name.includes('_CSS')) {
							let cssAttributeName = variable.name.toLowerCase().substring(0, variable.name.indexOf('_'))
							let cssAttributeValue = variable.value
							let cssAttributeSelector = variable.selector || 'footer'
							if (cssAttributeValue && cssAttributeValue !== '') {
								if (cssAttributeName === 'font-family') {
									if (!this.fontsCss.includes(cssAttributeValue)) {
										this.fontsCss += `@import url('https://fonts.googleapis.com/css?family=${cssAttributeValue}&display=swap');\n`
									}
									homepageCss += `${cssAttributeSelector} {\n ${cssAttributeName}:'${cssAttributeValue}';\n }\n`
								} else {
									homepageCss += `${cssAttributeSelector} {\n ${cssAttributeName}:${cssAttributeValue};\n }\n`
								}
							}
						}
					}
				})
			})

			this.homepageCss = homepageCss
		},

		getHomepageHTML(theme, homepage) {
			juniperApi
				.post('/themes/' + theme + '/homepage-html', {
					clientId: this.client.id,
					type: homepage,
					themeCss: this.themeCss,
					fontsCss: this.fontsCss,
					headerCss: this.headerCss,
					footerCss: this.footerCss,
					header: this.header,
					footer: this.footer,
					homepageSections: this.homepageSections,
				})
				.then(({ data }) => {
					this.websiteData = data
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Update preview
		 * Function updates html when property is changed
		 */
		updatePreview(e) {
			if (e.type === 'footer') {
				this.updateFooterPreview(this.footer)
			}
			if (e.type === 'header') {
				this.updateHeaderPreview(this.header)
			}
			if (e.type === 'homepage') {
				let section = this.homepageSections[e.sectionIndex]
				this.updateSectionPreview(section)
			}
			if (e.type === 'theme-settings') {
				this.updateThemeSettingsPreview()
			}
		},

		/**
		 * Update Header Preview
		 * Function return updated header content
		 */
		updateHeaderPreview(header) {
			juniperApi
				.post('/themes/' + this.themeOptions.theme_active + '/customizer/update-header-preview', {
					variables: header.variables,
					header: this.themeOptions.theme_header_active,
					clientId: this.client.id,
				})
				.then(({ data }) => {
					this.header.html = data
					this.updateHeaderCss(this.header)
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Update Section Content Preview
		 * Function returns updated section content
		 */
		updateSectionPreview(section) {
			juniperApi
				.post('/themes/' + this.themeOptions.theme_active + '/customizer/update-section-preview', {
					variables: section.variables,
					section: section.name,
					clientId: this.client.id,
				})
				.then(({ data }) => {
					section.content = data
					this.updateHomepageSectionsCss()
					this.executeScript(this.header.js)
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Update Footer Preview
		 * Function return updated footer content
		 */
		updateFooterPreview(footer) {
			juniperApi
				.post('/themes/' + this.themeOptions.theme_active + '/customizer/update-footer-preview', {
					variables: footer.variables,
					footer: this.themeOptions.theme_footer_active,
					clientId: this.client.id,
				})
				.then(({ data }) => {
					this.footer.html = data
					this.updateFooterCss(this.footer)
				})
				.catch(error => {
					console.log(error)
				})
		},

		/**
		 * Update Theme Settings Preview
		 * Function update root settings for theme with selected data
		 */
		updateThemeSettingsPreview() {
			let css = ':root{'
			let importFont = ''
			if (this.themeOptions && this.themeOptions.theme_settings_json) {
				this.themeOptions.theme_settings_json.forEach(setting => {
					let variableName = setting.code.toLowerCase().replace('_', '-')
					if (setting && setting.value && variableName.includes('font') && setting.value !== '') {
						let fontName = setting.value.replace(' ', '+')
						importFont += "@import url('https://fonts.googleapis.com/css?family=" + fontName + "&display=swap');\n"
					}
					css += '--' + variableName + ':' + setting.value + ';'
				})
			}
			css += '}'
			css = importFont + css
			this.settingsCss = css
		},

		// Insert photo from media library modal
		insertPhoto(photoUrl) {
			this.mediaElement.value = photoUrl
			this.$mediaModal.hide()
		},

		// Show media library modal
		showMediaModal(e) {
			this.mediaElement = e
			this.$mediaModal.show()
		},

		// Hide media library modal
		hideMediaModal() {
			this.$mediaModal.hide()
		},

		// Show select data modal
		showDataSelectModal(e) {
			this.dataSelectType = e.type
			this.dataSelectItem = e.item
			this.dataSelectSectionIndex = e.sectionIndex
			this.dataSelectSectionType = e.sectionType
			this.$dataSelectModal.show()
		},

		selectDataItem(e) {
			this.dataSelectItem.forEach(item => {
				if (e[item.name.toLowerCase()]) {
					item.value = e[item.name.toLowerCase()]
				}
			})
			this.updatePreview({ type: this.dataSelectSectionType, sectionIndex: this.dataSelectSectionIndex })
			this.hideDataSelectModal()
		},

		// Hide select data modal
		hideDataSelectModal() {
			this.$dataSelectModal.hide()
		},

		// Get Client Setting
		getClientThemeSettings(theme, clientId) {
			juniperApi
				.get('themes/' + theme + '/' + clientId + '/theme-settings')
				.then(({ data }) => {
					this.themeOptions.theme_settings_json = data
				})
				.catch(e => {
					console.log(e)
				})
		},

		selectCustomizerData(id) {
			this.getClientThemeOptions(id)
			/* this.updateFooterPreview(this.footer)
			this.updateHeaderPreview(this.header)
			this.homepageSections.forEach(sec => {
				this.updateSectionPreview(sec)
			})
			this.updateThemeSettingsPreview() */
		},

		applyChangedData() {
			this.updateFooterPreview(this.footer)
			this.updateHeaderPreview(this.header)
			this.homepageSections.forEach(sec => {
				this.updateSectionPreview(sec)
			})
			this.updateThemeSettingsPreview()
		},
	},
}
</script>
<style scoped>
.clients-wrapper {
	max-height: 600px;
	overflow: auto;
}
.client-data {
	display: flex;
	justify-content: start;
	align-items: center;
}
.section-customize-btn {
	position: absolute;
	z-index: 999;
	left: 10px;
}
</style>
